import { timesheetList } from "constants/timesheet";
const initialState = {
  timesheetList: {},
};

const timesheet = (state = initialState, action) => {
  switch (action.type) {
    case timesheetList:
      return { ...state, timesheetList: action.payload };

    default:
      return state;
  }
};
export default timesheet;
